module.exports = __webpack_public_path__ + "img/ilya.t__600x600.531c8c86.jpg";